export class RateLimiter {
  private requestTimestamps: number[] = [];
  private readonly maxRequests = 10;
  private readonly windowMs = 60000; // 1 minute

  async waitForSlot(): Promise<void> {
    const now = Date.now();

    // Remove timestamps older than the window
    this.requestTimestamps = this.requestTimestamps.filter(
      timestamp => now - timestamp < this.windowMs,
    );

    // If we're at the limit, wait until the oldest request expires
    if (this.requestTimestamps.length >= this.maxRequests) {
      const oldestTimestamp = this.requestTimestamps[0] || now;
      const waitTime = this.windowMs - (now - oldestTimestamp);

      if (waitTime > 0) {
        await new Promise(resolve => setTimeout(resolve, waitTime));
        // Recursively check again after waiting
        return this.waitForSlot();
      }
    }
  }

  recordRequest(): void {
    this.requestTimestamps.push(Date.now());
  }
}
